import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button as PrimeButton } from 'primereact/button';
import { Form } from 'react-bootstrap';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { API_END_POINT } from '../../config';
import { Toast } from 'primereact/toast'
import MaintenanceDialog from './MaintenanceDialog';
import Loader from '../../components/Loader/Loader';
import "./admin.css";
import { Tag } from 'primereact/tag';


const AdminListPage = ({ email }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0
    });
    const [dialogVisible, setDialogVisible] = useState(false);
    const [dialogMode, setDialogMode] = useState('Create');
    const [selectedRowData, setSelectedRowData] = useState(null);
    const toast = useRef(null);


    const fetchData = async (page = 0, size = 10) => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_END_POINT.BASE_URL.CI_SERVICE}/api/maintenance?page=${page}&size=${size}`);
            // toast.current.show({ severity: 'success', summary: 'Success', detail: 'Data Loaded Sucessfully, this is to check how much big it is' });

            const { content, totalElements } = response?.data;
            setData(content || []);
            setTotalRecords(totalElements);
        } catch (error) {
            // console.error('Error fetching data:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data', life: 3000 })
            setData([]);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchData(lazyParams.page, lazyParams.rows);
    }, [lazyParams]);

    const onPage = (event) => {
        setLazyParams({
            first: event.first,
            rows: event.rows,
            page: event.page
        })
    }

    const formatDate = (timeStamp) => {
        if (!timeStamp) return 'N/A';
        return new Date(timeStamp).toLocaleString();
    }

    const columnHandler = (rowData) => {
        switch (rowData) {
            case "Completed": {
                return (
                    <Tag value={rowData} severity="success"
                        style={{ width: '100%', justifyContent: 'center', fontSize: '14px' }} />
                )
            }
            case "Scheduled": {
                return (
                    <Tag value={rowData} severity="warning"
                        style={{ width: '100%', justifyContent: 'center', fontSize: '14px' }} />
                )
            }
            case "InProgress": {
                return (
                    <Tag value={rowData} severity="info"
                        style={{ width: '100%', justifyContent: 'center', fontSize: '14px' }} />
                )
            }
            default: { return <></> }
        }
    }

    // const handleSwitchChange = (rowData) => {
    //     console.log('Switch toggled for:', rowData);
    //     // api call should happen
    // };
    const handleSwitchChange = async (rowData) => {
        const updatedStatus = rowData.active === 1 ? 0 : 1;

        const payload = {
            maintenanceTitle: rowData.maintenanceTitle,
            moduleId: rowData.moduleId,
            startDate: rowData.startDate,
            endDate: rowData.endDate,
            active : updatedStatus,
        };

        try {
            // API call to update the 'active' status
            await axios.put(`${API_END_POINT.BASE_URL.CI_SERVICE}/api/maintenance/${rowData.maintenanceId}?email=${email}`, payload);


            // Show success toast
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: `Status updated successfully`,
                life: 2000,
            });

            // Update the UI state
            const updatedData = data.map(item =>
                item.maintenanceId === rowData.maintenanceId
                    ? { ...item, active: updatedStatus }
                    : item
            );
            setData(updatedData);
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to update status',
                life: 3000,
            });
        }
    };



    const handleEditClick = async (rowData) => {
        try {
            const response = await axios.get(`${API_END_POINT.BASE_URL.CI_SERVICE}/api/maintenance/${rowData?.maintenanceId}`);

            setSelectedRowData({
                ...response.data,
                startDate: new Date(response.data.startDate),
                endDate: new Date(response.data.endDate),

            })
            setDialogMode('edit');
            setDialogVisible(true);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to load edit data', life: 3000 })

        }
    }
    const handleCreateClick = () => {
        setDialogMode('create');
        setSelectedRowData(null);
        setDialogVisible(true);
    }

    const handleDialogClose = (shouldRefresh = false) => {
        setDialogVisible(false);
        if (shouldRefresh) {
            fetchData(lazyParams.page, lazyParams.rows);
        }
    }

    const actionBodyTemplate = (rowData) => (
        <div className="d-flex align-items-center gap-2">
            <PrimeButton
                icon="pi pi-pencil"
                className="p-button-sm p-button-text"
                onClick={() => handleEditClick(rowData)}
                disabled={rowData.maintenanceStatus === "Completed"}
            />
            {/* <PrimeButton
                icon="pi pi-trash"
                className="p-button-sm p-button-danger p-button-text"
                onClick={() => alert('Delete: ' + rowData.moduleName)}
            /> */}
            <Form.Check
                type="switch"
                id={`switch-${rowData.maintenanceId}`}
                checked={rowData.active === 1 || false}
                onChange={() => handleSwitchChange(rowData)}
                disabled={rowData.maintenanceStatus === "Completed"}
            />
        </div>
    );



    return (
        <>
            <Toast ref={toast} />

            {loading ? (<Loader />) : (<div>
                <div className='d-flex justify-content-between align-items-center mb-3' style={{ marginTop: '45px' }}>
                    {/* <h2 className="mb-4">Admin List for {email}</h2> */}
                    <h2 className="mb-4">{ }</h2>
                    <PrimeButton label='Create Maintenance' icon="pi pi-plus" className='my-create-button' onClick={handleCreateClick} />
                </div>
                <DataTable
                    value={data}
                    lazy
                    // loading={loading}
                    paginator
                    totalRecords={totalRecords}
                    first={lazyParams.first}
                    rows={lazyParams.rows}
                    onPage={onPage}
                    rowsPerPageOptions={[10, 20, 50]}
                    responsiveLayout="scroll"
                    tableStyle={{ minWidth: '60rem' }}
                // className='p-datatable-sm'
                >
                    <Column field="moduleName" header="Module Name" />
                    <Column field="maintenanceTitle" header="Maintenance Title" />
                    <Column field="startDate" header="Start Date" body={(rowData) => formatDate(rowData.startDate)} />
                    <Column field="endDate" header="End Date" body={(rowData) => formatDate(rowData.endDate)} />
                    <Column field="maintenanceStatus" header="Maintenance Status" body={(rowData) => columnHandler(rowData.maintenanceStatus)} />
                    <Column body={actionBodyTemplate} header="Actions" />
                </DataTable>
                <MaintenanceDialog
                    visible={dialogVisible}
                    onHide={handleDialogClose}
                    mode={dialogMode}
                    selectedRowData={selectedRowData}
                    toast={toast}
                    email={email}
                />
            </div>)}

        </>
    );
};



export default AdminListPage;